import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { BrowserModule } from "@angular/platform-browser";
import { NgModule, ApplicationRef } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { RouterModule, Routes } from "@angular/router";

import { AngularFireModule } from "angularfire2";
import { AngularFirestoreModule } from "angularfire2/firestore";
import { AngularFireAuthModule } from "angularfire2/auth";
import { AuthService } from "./core/auth.service";
import { AuthGuard } from "./core/auth.guard";
import { AngularFireDatabase } from "angularfire2/database";

import { environment } from "../environments/environment";

import { CoreModule } from "./core/core.module";

import { AppComponent } from "./app.component";
import { HomeComponent } from "./components/home/home.component";
import { CampervansComponent } from "./components/campervans/campervans.component";
import { NavbarComponent } from "./components/navbar/navbar.component";
import { FooterComponent } from "./components/footer/footer.component";
import { CampervanComponent } from "./components/campervan/campervan.component";
import { AddCampervanComponent } from "./components/add-campervan/add-campervan.component";
import { EditCampervanComponent } from "./components/edit-campervan/edit-campervan.component";
import { LoginComponent } from "./components/login/login.component";
import { UserprofileComponent } from "./components/userprofile/userprofile.component";
import { RegisterComponent } from "./components/register/register.component";
import { FireBaseService } from "./services/firebase.service";
import { UserlistComponent } from "./components/userlist/userlist.component";
import { UserdetailComponent } from "./components/userdetail/userdetail.component";
import { UploadFormComponent } from "./storage/uploads/upload-form/upload-form.component";
import { UploadService } from "./storage/uploads/shared/upload.service";
import { RemoveService } from "./storage/remove/remove.service";
import { MessagingService } from "./services/messaging.service";

import { AgmCoreModule } from "@agm/core";
import { AgmJsMarkerClustererModule } from "@agm/js-marker-clusterer";
import { AgmSnazzyInfoWindowModule } from "@agm/snazzy-info-window";
import { MessageListComponent } from "./components/messaging/message-list/message-list.component";
import { MessageFormComponent } from "./components/messaging/message-form/message-form.component";

import { RecaptchaModule } from "ng-recaptcha";
import { RECAPTCHA_SETTINGS, RecaptchaSettings } from "ng-recaptcha";
import { FollowService } from "./services/follow.service";

import { ChatModule } from './chat/chat.module';
import { ChatDialogComponent } from "./chat/chat-dialog/chat-dialog.component";
import { AboutComponent } from './components/about/about.component';
import { ContactusComponent } from './components/contactus/contactus.component';
import { FollowComponent } from './components/follow/follow.component';
import { MapTestComponent } from './components/map-test/map-test.component';


const appRoutes: Routes = [
  { path: "", component: HomeComponent, data: { state: "home" } },
  { path: "home", component: HomeComponent, data: { state: "home" } },
  {
    path: "campervans",
    component: CampervansComponent,
    data: { state: "campervans" }
  },
  { path: "about", component: AboutComponent},
  { path: "contact", component: ContactusComponent},
  { path: "chat", component: ChatDialogComponent },
  { path: "login", component: LoginComponent },
  { path: "register", component: RegisterComponent },
  { path: "users", component: UserlistComponent },
  { path: "user/:id", component: UserdetailComponent},
  { path: 'mapTest', component: MapTestComponent},
  {
    path: "user/:id/message",
    component: MessageFormComponent,
    canActivate: [AuthGuard]
  },
  {
    path: "add-campervan",
    component: AddCampervanComponent,
    canActivate: [AuthGuard]
  },
  {
    path: "userprofile",
    component: UserprofileComponent,
    canActivate: [AuthGuard]
  },
  {
    path: "messagelist",
    component: MessageListComponent,
    canActivate: [AuthGuard]
  },
  { path: "**", component: HomeComponent }
];

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    CampervansComponent,
    NavbarComponent,
    FooterComponent,
    CampervanComponent,
    AddCampervanComponent,
    EditCampervanComponent,
    LoginComponent,
    UserprofileComponent,
    RegisterComponent,
    UserlistComponent,
    UserdetailComponent,
    UploadFormComponent,
    MessageListComponent,
    MessageFormComponent,
    AboutComponent,
    ContactusComponent,
    FollowComponent,
    MapTestComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule.forRoot(appRoutes),
    AngularFireModule.initializeApp(environment.firebase),
    AngularFirestoreModule,
    AngularFireAuthModule,
    AgmCoreModule.forRoot({
      apiKey: environment.googleMapsAPIKey,
      libraries: ["places"]
    }),
    AgmJsMarkerClustererModule,
    AgmSnazzyInfoWindowModule,
    RecaptchaModule.forRoot(),
    BrowserAnimationsModule,
    ChatModule
  ],
  providers: [
    FireBaseService,
    AngularFireDatabase,
    AuthService,
    AuthGuard,
    UploadService,
    RemoveService,
    MessagingService,
    FollowService,
    {
      provide: RECAPTCHA_SETTINGS,
      useValue: {
        siteKey: "6LfJYEEUAAAAAOAre9GW49wzag3hLc0IVZctYJkp"
      } as RecaptchaSettings
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}



// WEBPACK FOOTER //
// /Users/akirchhoff/Documents/Development/loveyourcamper-app/src/app/app.module.ts